import React, { useState, useCallback, useEffect } from "react";
import { Col, Row, Card, Form, Input, TreeSelect } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { includes, map, get, toLower, size, join } from "lodash";
import { PAGINATION } from "../../_redux/constant";
import { barrierThunks } from "../../_redux/thunk";
import AppBaseSelect from "../../../../../core/components/baseSelect";
import { removeVietnameseTones } from "../../../../../lib/admin";
import {
  convertObjToArrObj,
  convertStationGate
} from "../../../../../lib/util";
import Gate from "../../components/gate/gateList";
import AddEditGate from "../../components/gate/modals/addEditGate";

let timer = null;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const { TreeNode } = TreeSelect;
function BarrierGatePage() {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const listStation = useSelector(x => x.app.listStationsV2Select);
  const { direction, stations, station_gates } = useSelector(
    state => state.barrier.barrierLog.filterData
  );

  const { data: allStations } = useSelector(
    state => state.barrier.barrierGate.station
  );

  const { data, total_elements } = useSelector(
    state => state.barrier.barrierGate.gate
  );

  const [params, setParams] = useState({
    size: PAGINATION.gate.size,
    page: PAGINATION.gate.page
  });

  const [tableData, setTableData] = useState({
    dataSource: [],
    total: 0
  });

  const [loading, setLoading] = useState(false);

  const [activeKey, setActiveKey] = useState("all");

  const [modalState, setModalState] = useState({
    visible: false
  });

  const dataSource = map(data, (item, index) => ({
    ...item,
    stt:
      params.page === 0
        ? index + 1
        : (params.page - 1) * params.size + index + 1
  }));

  const _handleGetFilterData = useCallback(async () => {
    await dispatch(barrierThunks.getLogFilterDataThunk());
  }, []);

  const _handleGetGates = useCallback(
    async () => {
      setLoading(true);
      await dispatch(barrierThunks.getGatesThunk(params));
      setLoading(false);
    },
    [params]
  );

  const _handleGetStations = useCallback(async () => {
    setLoading(true);
    await dispatch(barrierThunks.getStationThunk());
    setLoading(false);
  }, []);

  const _handleChangeInput = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      clearTimeout(timer);
      _handleChangeFilter();
    }, 800);
  };

  const _handleChangeFilter = () => {
    const { direction, station_id, ip } = form.getFieldsValue();

    setParams(prev => ({
      ...prev,
      direction,
      station_id,
      ip,
      page: PAGINATION.camera.page,
      size: PAGINATION.camera.size
    }));
  };

  const _handleShowModal = () => {
    setModalState(prev => ({
      ...prev,
      visible: !prev.visible,
      isEdit: false,
      stations: listStation
    }));
  };

  const onChangeParam = param => {
    if (!param.page && !param.size) {
      param.page = PAGINATION.camera.page;
      param.size = PAGINATION.camera.size;
    }
    setParams(prev => ({ ...prev, ...param }));
  };

  const _handleChangeParam = useCallback(async ({ stationIds }) => {
    setParams(prev => ({
      ...prev,
      station_ids:
        stationIds && size(stationIds) && size(join(stationIds, ","))
          ? join(stationIds, ",")
          : "",
      page: PAGINATION.camera.page,
      size: PAGINATION.camera.size
    }));
  }, []);

  useEffect(
    () => {
      _handleGetFilterData();
      _handleGetGates();
      _handleGetStations();
    },
    [_handleGetFilterData, _handleGetGates, _handleGetStations]
  );

  return (
    <Row className="barrier-log__page" gutter={[8, 8]}>
      <Col span={24}>
        <Card
          bodyStyle={{ paddingBottom: "0" }}
          size="small"
          style={CARD_STYLE}
        >
          <Row align="middle" justify="space-between" span={24}>
            <Form form={form} layout={"vertical"} style={{ width: "100%" }}>
              <Row gutter={[16, 0]}>
                <Col className="gutter-row" md={8} xs={24}>
                  <Form.Item
                    colon={false}
                    label="Kho"
                    labelAlign="left"
                    labelCol={{ span: 3 }}
                  >
                    <TreeSelect
                      disabled={activeKey !== "all"}
                      multiple
                      dropdownStyle={{
                        maxHeight: 400,
                        overflow: "auto",
                        overflowX: "hidden"
                      }}
                      filterTreeNode={(input, treeNode) => {
                        return includes(
                          toLower(
                            removeVietnameseTones(get(treeNode, "title"))
                          ),
                          toLower(removeVietnameseTones(input))
                        );
                      }}
                      placeholder="Chọn kho"
                      showCheckedStrategy={SHOW_PARENT}
                      style={{ width: "100%" }}
                      treeCheckable={true}
                      onChange={data => {
                        _handleChangeParam(convertStationGate(data, stations));
                      }}
                    >
                      {map(station_gates, station => {
                        return (
                          <TreeNode
                            key={station.station_name}
                            selectable={false}
                            title={station.station_name}
                            value={station.station_name}
                          >
                            {map(station.gates, gate => {
                              return (
                                <TreeNode
                                  key={gate.gate_id}
                                  selectable={false}
                                  title={gate.gate_name}
                                  value={gate.gate_id}
                                />
                              );
                            })}
                          </TreeNode>
                        );
                      })}
                    </TreeSelect>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
        </Card>
      </Col>
      <Col span={24}>
        <Gate
          loading={loading}
          dataSource={dataSource}
          total_elements={total_elements}
          params={params}
          onChangeParam={onChangeParam}
          onClickCreate={_handleShowModal}
          allStations={listStation}
        />
      </Col>
      <AddEditGate modal={modalState} onShowModal={_handleShowModal} />
    </Row>
  );
}

export default React.memo(BarrierGatePage);
